const HightLightContent = ({
  highlightStringArr,
  commonStringArr,
}: {
  commonStringArr: string[];
  highlightStringArr: string[];
}) => {
  return (
    <>
      {highlightStringArr.map((value, index) => {
        return (
          <span key={value}>
            {commonStringArr[index]}
            <span style={{ color: 'red' }}>{value}</span>
          </span>
        );
      })}
      {commonStringArr[commonStringArr.length - 1]}
    </>
  );
};

export default HightLightContent;
